export default __webpack_public_path__ + "static/media/a4.98b11316.png";